module.exports = "<app-header></app-header>\n<div class=\"app-body\">\n    <app-sidebar></app-sidebar>\n    <!-- Main content -->\n    <main class=\"main\">\n        <!-- Breadcrumb -->\n        <ol class=\"breadcrumb\">\n            <app-breadcrumbs></app-breadcrumbs>\n        </ol>\n        <div class=\"container-fluid\">\n            <router-outlet></router-outlet>\n        </div>\n        <!-- /.conainer-fluid -->\n    </main>\n</div>\n<app-footer></app-footer>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/containers/full-layout/full-layout.component.html
// module id = ../../../../../src/app/containers/full-layout/full-layout.component.html
// module chunks = main